import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import QuickLinks from "@/components/landing/QuickLinks";
import Services from "@/components/landing/Services";
import Pricing from "@/components/landing/Pricing";
import Testimonials from "@/components/landing/Testimonials";
import About from "@/components/landing/About";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "JT Brand Scales — Scale your brand in Kentucky";
  }, []);

  return (
    <main data-testid="landing-page" className="relative">
      <Navbar />
      <Hero />
      <QuickLinks />
      <Services />
      <Pricing />
      <Testimonials />
      <About />
      <Contact />
      <Footer />
    </main>
  );
}
